module.exports = "pegasus_template/assets/header-fall-pets-2.jpg";